import {Capacitor} from '@capacitor/core';
import {AppUpdate, AppUpdateAvailability, FlexibleUpdateInstallStatus} from '@capawesome/capacitor-app-update';

export const useAppUpdate = () => {
  const getCurrentAppVersion = async () => {
    const result = await AppUpdate.getAppUpdateInfo();
    if (Capacitor.getPlatform() === 'android') {
      return result.currentVersionCode;
    } else {
      return result.currentVersionName;
    }
  };

  const getAvailableAppVersion = async () => {
    const result = await AppUpdate.getAppUpdateInfo();
    if (Capacitor.getPlatform() === 'android') {
      return result.availableVersionCode;
    } else {
      return result.availableVersionName;
    }
  };

  const openAppStore = async () => {
    await AppUpdate.openAppStore();
  };

  const startFlexibleUpdate = async () => {
    const result = await AppUpdate.getAppUpdateInfo();
    if (result.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) {
      return;
    }
    if (result.flexibleUpdateAllowed) {
      AppUpdate.addListener('onFlexibleUpdateStateChange', async (state) => {
        if (state.installStatus === FlexibleUpdateInstallStatus.DOWNLOADED) {
          await AppUpdate.completeFlexibleUpdate();
        }
      })
      await AppUpdate.startFlexibleUpdate();
    }
  };

  const checkIfAppUpdateAvailable = async () => {
    console.log('[AppUpdate] checkIfAppUpdateAvailable — platform:', Capacitor.getPlatform())
    try {
      if (!Capacitor.isNativePlatform()) return false;

      const result = await AppUpdate.getAppUpdateInfo();
      console.log('[AppUpdate] Full update info:', JSON.stringify(result));

      const currentAppVersion = Capacitor.getPlatform() === 'android' ? result.currentVersionCode : result.currentVersionName;
      const availableAppVersion = Capacitor.getPlatform() === 'android' ? result.availableVersionCode : result.availableVersionName;

      console.log(`[AppUpdate] current: ${currentAppVersion} | available: ${availableAppVersion} | updateAvailable: ${currentAppVersion !== availableAppVersion}`)
      return currentAppVersion !== availableAppVersion;
    } catch (e) {
      console.log('[AppUpdate] Failed in checkIfAppUpdateAvailable', e);
      return false;
    }
  }

  const runAppUpdate = async () => {
    if (!Capacitor.isNativePlatform()) return;

    if (Capacitor.getPlatform() === 'android') {
      await startFlexibleUpdate();
    } else {
      await openAppStore()
    }
  }

  return {
    checkIfAppUpdateAvailable,
    runAppUpdate
  }
}
